import {makeStyles} from "@material-ui/core/styles";

export const  useStyles = makeStyles(() => ({
    root:{
        display:'flex',
        alignItems:'center',
        justifyContent: 'space-between',
        marginBottom: 20
    },
    buttonStyle:{
        width: 180,
        height: 36,
        padding: 0,
        background: '#2556F5',
        borderRadius: 4,
        '&:hover':{
            background: '#2556F5',
        },
        '& p':{
            fontSize: '0.875rem',
            color: '#fff',
            fontWeight: 700,
            marginLeft: 8
        },
        '&.Mui-disabled':{
           background: 'rgba(16, 18, 28, 0.30)',
            '& p':{
               color: 'rgba(255, 255, 255, 0.70)'
            },
            '& path':{
               stroke:'rgba(255, 255, 255, 0.70)'
            }
        }
    },
    buttonStyle2:{
        background: '#8125F5',
        marginLeft: 13,
        '&:hover':{
            background: '#8125F5',
        },
    },
    buttonStyle3:{
        width: 70,
        background: '#10121C',
        marginLeft: 16,
        '& p':{
            marginLeft: 0
        },
        '&:hover':{
            background: '#10121C',
        },
    },
    popoverBox:{
        '& .MuiPaper-root':{
            minWidth: 180,
            border: '1px solid #BCBCBC',
            background: '#fff',
            boxShadow:'0px 2px 4px 0px rgba(0, 0, 0, 0.40)',
            padding: '8px 3px',
            boxSizing: 'border-box',
            borderRadius: 4,
            '& *': {
                fontFamily: 'Pretendard !important',
                letterSpacing: '-0.5px'
            },
            '& ul':{
                padding: 0,
                '& li':{
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: '#10121c',
                    padding: '6px 31px',
                    '&:hover':{
                        background: 'rgba(85, 121, 240, 0.2)'
                    }
                }
            }
        }
    },
    textStyle:{
        fontSize: '0.875rem',
        fontWeight: 700,
        color: '#10121c',
        marginRight: 8,
    },
    marginLeft30:{
        marginLeft: 30
    },
    formControlBox:{
        marginRight: 16,
        '& .MuiInputBase-root':{
            width: 90,
            height: 36,
            borderRadius: 5,
            background: '#fff',
            padding: '0 6px 0 12px',
            '& input':{
                padding: 0,
                fontSize: '0.875rem',
                color: '#10121c',
                fontWeight: 500,
                letterSpacing: '-0.395px'
            },
            '&.Mui-disabled':{
                '& input':{
                    color: 'rgba(16, 18, 28, 0.5)',
                },
                '& path':{
                    stroke:'rgba(16, 18, 28, 0.5)',
                }
            }
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
            border: '1px solid #10121C'
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline':{
            border: '2px solid #E82357'
        }
    },
    iconButton:{
        padding: 0,
        '&:hover':{
            background: 'transparent'
        },
        '&.Mui-disabled':{
            '& path':{
                stroke:'rgba(16, 18, 28, 0.5)',
            }
        }
    },
    checkBoxStyle:{
        '&.MuiFormControlLabel-root':{
            margin: 0,
            '& .MuiButtonBase-root':{
                padding: 0
            },
            '& .MuiFormControlLabel-label':{
                fontSize: '0.875rem',
                color: '#10121c',
                fontWeight: 700,
                letterSpacing: '-0.4px',
                marginRight: 8
            }
        }
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
        },
        '& .MuiSelect-select':{
            width: 90,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            fontSize: '1.125rem',
            color:'#323232',
            boxSizing: 'border-box',
            '&:hover':{
                background: '#eee !important'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
        }
    },
}));

